import { tr } from 'mmfintech-commons'
import { isValidArray } from 'mmfintech-commons'
import styles from './OtherCurrencies.module.scss'
import { SelectionElement } from './SelectionElement'

export const OtherCurrencies = ({ currencies, onClick, setInputFocused }) => {
  return isValidArray(currencies) ? (
    <>
      <div className={styles['other-currencies-label']}>
        {' '}
        {tr('FRONTEND.OTHER_CURRENCIES.OTHER_CURRENCIES', 'Other currencies')}{' '}
      </div>
      {currencies.map(option => {
        const { currencyFullName } = option

        return (
          <SelectionElement
            data-test='selected-content'
            key={currencyFullName}
            data={option}
            type='account'
            hideCaption={false}
            onSelect={() => {
              onClick(null, { ...option, name: currencyFullName })
            }}
            setInputFocused={setInputFocused}
          />
        )
      })}
    </>
  ) : null
}
